__turbopack_context__.v({
  "infoIcon": "OpenOnDesktopMenuButton-module__XuiNia__infoIcon",
});
